<template>
  <teleport to="body">
    <transition name="cdlg">
      <div
        v-if="open"
        class="cdlg"
        role="alertdialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        :aria-describedby="descId"
        @keydown.esc.prevent="onCancel"
      >
        <button type="button" class="cdlg__catch" aria-label="닫기" @click="onCancel" />
        <div class="cdlg__panel" ref="panelRef">
          <h2 :id="titleId" class="cdlg__title">{{ title }}</h2>
          <p :id="descId" class="cdlg__message">{{ message }}</p>
          <pre v-if="detail" class="cdlg__detail">{{ detail }}</pre>
          <div class="cdlg__actions">
            <button type="button" class="cdlg__btn" @click="onCancel">
              {{ cancelLabel }}
            </button>
            <button
              type="button"
              class="cdlg__btn cdlg__btn--confirm"
              :class="`is-${tone}`"
              ref="confirmRef"
              @click="onConfirm"
            >
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { useConfirmDialogHost } from '@/composables/useConfirmDialog'

const uid = `cdlg-${Math.random().toString(36).slice(2, 9)}`
const titleId = `${uid}-title`
const descId = `${uid}-desc`
const panelRef = ref<HTMLElement | null>(null)
const confirmRef = ref<HTMLButtonElement | null>(null)

const {
  open,
  title,
  message,
  detail,
  confirmLabel,
  cancelLabel,
  tone,
  onConfirm,
  onCancel,
} = useConfirmDialogHost()

watch(open, async (value) => {
  if (!value) return
  await nextTick()
  confirmRef.value?.focus()
})
</script>

<style lang="scss" src="./ConfirmDialog.scss"></style>
